<template>
  <div class="container">
    <div class="mwow-top-title">
      <span class="text">资源管理</span>
    </div>
    <resource></resource>
  </div>
</template>
<script>
import resource from "./resource.vue";
export default {
  components: {
    resource,
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
}
</style>
